module.exports = __webpack_public_path__ + "img/music-right3.579e8243.png";